<template>
  <div class="signin-container">
    <div style="margin-bottom: 100px">
      <div class="booking-information__container">
        <div
          style="margin-top: 60px"
          v-if="!storeData.root_name"
          v-loading="true"
        />
        <div v-else>
          <div class="store-name">
            <span
              >{{ storeData.root_name }} | {{ storeData.display_name }}</span
            >
          </div>
          <a
            :href="`https://maps.google.com/?q=${storeData.display_location_name},${storeData.display_location_state}`"
            target="_blank"
            class="row-info mt15"
          >
            <div class="icon-info-wrapper">
              <img src="@/assets/ic_home_location.png" class="icon-info" />
            </div>
            <span style="line-height: 25px; font-size: 14px"
              >{{ storeData.display_location_name }},
              <br />
              <span>{{ storeData.display_location_state }}</span>
            </span>
          </a>
          <a :href="`tel:${storeData.phone_number}`" class="row-info mt12">
            <div class="icon-info-wrapper">
              <img src="@/assets/ic_home_phone.png" class="icon-info" />
            </div>
            <span style="font-size: 14px">{{ storeData.phone_number }}</span>
          </a>
        </div>

        <div class="body-container phone-number">
          <span class="title mb20 mt30">Booking phone number</span>
          <PhoneInput
            @input="phoneInput"
            :error="phoneNumber.error"
            placeholder="Your Phone Number"
          />
          <div class="text-field" v-loading="gettingName">
            <input v-model="email" class="input" placeholder="Email" />
          </div>
        </div>
        <div class="body-container time">
          <div class="datetime-container">
            <div class="date-container">
              <span class="title mb20">Date & Time</span>
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  width: 100%;
                "
              >
                <el-date-picker
                  style="width: calc(50% - 5px)"
                  type="date"
                  placeholder="Pick a date"
                  v-model="datePicker"
                  @change="openTimePicker"
                  :picker-options="pickerOptions"
                  format="MM/dd"
                ></el-date-picker>
                <el-select
                  ref="timePicker"
                  v-model="timePicker"
                  placeholder="Select time"
                >
                  <el-option
                    v-for="item in getTimes()"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <customer-item
        v-for="(item, index) in customers"
        :key="`customer-${index}`"
        :customer="item"
        :services="services"
        :customerIndex="index"
        @openOtherNote="openOtherNote"
        @openTechnicianNote="openTechnicianNote"
        :gettingName="gettingName"
        @onRemove="onRemove"
      />
      <div class="add-button normal-button" @click="addCustomer">
        <img
          src="@/assets/ic_plus_gray.png"
          style="height: 20px; widht: auto; margin-right: 15px"
        />
        <span>Add Customer</span>
      </div>
    </div>
    <div class="cta-bottom">
      <gradient-button title="Make a Appoinment" @onClick="onBookingGroup" />
    </div>
    <el-dialog title="Notes" :visible.sync="dialogNote" :width="dialogWidth">
      <el-input
        v-model="note"
        autocomplete="off"
        placeholder="Enter your notes"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogNote = false">Cancel</el-button>
        <el-button style="margin-left: 10px" type="primary" @click="onConfirm"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogTechnician"
      :width="dialogWidth"
      center="true"
      @close="() => (dialogTechnician = false)"
    >
      <span class="tech-title" slot="title">Technicians</span>
      <div class="list-technician">
        <div
          v-for="(item, index) in technician"
          :key="item.user_id"
          class="btn-tech normal-button"
          v-bind:class="{
            left: index % 3 == 0,
            right: index % 3 == 2,
            center: index % 3 == 1,
          }"
          @click="() => onSelectTech(item)"
        >
          <span class="tech">{{ item.full_name }}</span>
        </div>
      </div>
      <div class="techniciant-field">
        <el-input
          v-model="technician_notes"
          placeholder="Enter technician name"
        />
        <el-button
          style="margin-left: 10px"
          v-if="technician_notes != ''"
          type="primary"
          @click="applyTechniciantNotes"
          >Confirm</el-button
        >
      </div>
    </el-dialog>
    <transition name="fade">
      <div v-if="otpDialog" class="overlay" />
    </transition>
    <transition name="slide">
      <div class="bottom-checkout-container confirm-alert" v-if="otpDialog">
        <img src="@/assets/confirmphone.png" class="logo-success" />
        <span class="message">Enter your verification code</span>
        <otp-view :length="6" @onChange="onVerify" class="otp-view" />
        <div
          class="continue-button normal-button"
          v-bind:class="{ 'continue-button-disable': resend > 0 }"
          @click="
            () => {
              resend == 0 && requestOtp();
            }
          "
        >
          <span class="continue-text"
            >Resend {{ resend > 0 ? `(${resend}s)` : "" }}</span
          >
        </div>
      </div>
    </transition>
    <purchase-success-alert
      v-if="isComplete && !isGroup"
      @onDismiss="onDismiss"
      :storeName="displayName"
    />
    <purchase-group-success
      v-if="isComplete && isGroup"
      @onDismiss="onDismiss"
      :urlGroup="urlGroup"
      @onCopyClick="onCopyClick"
    />
  </div>
</template>

<script>
import GradientButton from "@/components/GradientButton";
import PurchaseSuccessAlert from "@/components/PurchaseSuccessAlert";
import PurchaseGroupSuccess from "@/components/PurchaseGroupSuccess";
import {
  getServices,
  getTechnician,
  createTicket,
  getDisplayName,
  requestVerificationCode,
  verifyCode,
  findCustomer,
} from "@/api/home";
import { Message, Loading } from "element-ui";
import moment from "moment";
import PhoneInput from "@/components/PhoneInput";
import OtpView from "./components/OtpView";
import CustomerItem from "./components/CustomerItem";
import SocketUtils from "@/utils/SocketUtils";

const diffHour = new Date().getTimezoneOffset() / 60 - 5;
const currentDay = new Date();
const currentHour = new Date().getHours() + new Date().getMinutes() / 60;
const currentHourCompare = currentDay.getHours() + currentDay.getMinutes() / 60;
currentDay.setHours(currentHour + diffHour);

const nextDay = new Date(
  currentDay.getFullYear(),
  currentDay.getMonth(),
  currentDay.getDate() + 1
);

const defaultCustomer = {
  fullName: "",
  customerNote: "",
  tech: {},
  technicianNotes: "",
};

export default {
  name: "SignIn",
  components: {
    GradientButton,
    PurchaseSuccessAlert,
    PhoneInput,
    OtpView,
    PurchaseGroupSuccess,
    CustomerItem,
  },
  mounted() {
    document
      .querySelectorAll(".el-date-editor input")
      .forEach((e) => (e.readOnly = true));
  },
  data() {
    return {
      currentCustomerIndex: 0,
      customers: [{ ...defaultCustomer, selectedServices: [] }],
      technician_notes: "",
      datePicker: currentHourCompare > 22 ? nextDay : currentDay,
      timePicker: "",
      source: "Appointment",
      note: "",
      customerNote: "",
      pickerOptions: {
        disabledDate(time) {
          const isToday = moment(time).isSame(currentDay, "day");
          if (isToday) {
            return false;
          } else {
            return time.getTime() < currentDay;
          }
        },
      },
      email: "",
      phoneNumber: {
        obj: {
          number: {
            input: "",
          },
        },
        error: "",
      },
      services: [],
      technician: [],
      dialogNote: false,
      dialogTechnician: false,
      checked: false,
      displayName: "",
      isComplete: false,
      otpDialog: false,
      resend: 60,
      ticketData: null,
      storeName: null,
      groupId: null,
      groupName: null,
      storeData: {},
      gettingName: false,
    };
  },
  computed: {
    urlGroup() {
      return `${window.location.host}/booking?storename=${this.storeName}&group_id=${this.groupId}&group_name=${this.groupName}`;
    },
    device() {
      return this.$store.state.app.device;
    },
    dialogWidth() {
      if (this.device == "mobile") return "100%";
      return "600px";
    },
    dialogWidthOtp() {
      if (this.device == "mobile") return "80%";
      return "300px";
    },
    phoneInput() {
      const self = this;
      return (val, obj) => {
        if (obj.valid) {
          self.autoFullName(obj?.nationalNumber);
        }
        if (obj.valid) {
          self.phoneNumber.error = "";
        }
        self.phoneNumber.obj = obj;
      };
    },
    getDate() {
      if (this.datePicker == "") return "";
      return moment(this.datePicker).format("MM/DD");
    },
    getTime() {
      return this.timePicker;
    },
    todayActive() {
      const diff = moment(this.datePicker).diff(currentDay);
      return diff <= 0;
    },
    tomorrowActive() {
      const diff = moment(this.datePicker).diff(currentDay);
      return diff > 0 && diff <= 86400000;
    },
  },
  methods: {
    addCustomer() {
      this.customers.push({ ...defaultCustomer, selectedServices: [] });
    },
    onRemove(index) {
      this.customers.splice(index, 1);
    },
    getTimes() {
      const start = 8;
      const end = 22;
      const step = [0, 15, 30, 45];
      const res = [];
      for (let i = 0; i <= end - start; i++) {
        for (let j = 0; j < step.length; j++) {
          const hour = start + i;
          let min = step[j];
          if (!(hour == end && min > 0)) {
            let ms = 0;
            ms = hour * 60 * 60 * 1000 + min * 60 * 1000;
            const mls =
              new Date(moment(this.datePicker).format("MM/DD/YYYY")).getTime() +
              ms;
            const disabled = currentDay.getTime() > mls;
            res.push({
              label: moment.utc().hours(hour).minutes(min).format("hh:mm A"),
              value: moment.utc().hours(hour).minutes(min).format("HH:mm"),
              disabled,
            });
          }
        }
      }
      return res;
    },
    autoFullName(phone) {
      if (!phone) return;
      const self = this;
      this.gettingName = true;
      findCustomer(phone, this.storeName)
        .then((res) => {
          self.customers[0].fullName = res.full_name;
          self.email = res.email || "";
          this.gettingName = false;
        })
        .catch(() => {
          self.customers[0].fullName.val = "";
          self.email = "";
          this.gettingName = false;
        });
    },
    emitData() {
      if (!this.ticketData) return;
      SocketUtils.socket.emit("ON_BOOKING", {
        store_name: this.storeName,
        ticket_data: this.ticketData,
      });
      this.ticketData = null;
    },
    onVerify(val) {
      const phone_number = this.phoneNumber.obj.nationalNumber;
      verifyCode({
        phone_number: phone_number,
        store_name: this.storeName,
        verification_code: val.join(""),
      })
        .then(() => {
          this.isComplete = true;
          this.checked = false;
          this.otpDialog = false;
          this.emitData();
        })
        .catch(() => {});
    },
    requestOtp() {
      const phone_number = this.phoneNumber.obj.nationalNumber;
      requestVerificationCode({
        phone_number: phone_number,
        store_name: this.storeName,
      })
        .then((res) => {
          console.log(res);
        })
        .catch((e) => {
          console.log(e);
        });
      this.resend = 60;
      setInterval(() => {
        this.resend -= 1;
      }, 1000);
    },
    openTimePicker() {
      this.timePicker = "";
      this.$refs.timePicker.toggleMenu();
    },
    onCopyClick() {
      Message({
        message: "Copied",
        type: "success",
        duration: 2 * 1000,
      });
    },
    onDismiss() {
      this.isComplete = false;
      if (this.isGroup) {
        setTimeout(() => {
          location.reload();
        }, 1000);
      } else {
        location.reload();
      }
    },
    applyTechniciantNotes() {
      this.customers[
        this.currentCustomerIndex
      ].technicianNotes = this.technician_notes;
      this.customers[this.currentCustomerIndex].tech = {
        ...this.technician[0],
        full_name: this.technician_notes,
      };
      this.dialogTechnician = false;
    },
    onSelectTech(tech) {
      this.technician_notes = "";
      this.customers[this.currentCustomerIndex].tech = tech;
      this.dialogTechnician = false;
    },
    onConfirm() {
      this.customers[this.currentCustomerIndex].customerNote = this.note;
      this.dialogNote = false;
      const other = this.services.find((s) => s.type == "Other");
      const indexSelected = this.customers[
        this.currentCustomerIndex
      ].selectedServices.indexOf(other);
      if (this.note != "") {
        if (indexSelected > -1) return;
        this.customers[this.currentCustomerIndex].selectedServices.push(other);
      } else {
        if (indexSelected > -1) {
          this.customers[this.currentCustomerIndex].selectedServices.splice(
            indexSelected,
            1
          );
        }
        return;
      }
    },
    checkBookingEmpty(item) {
      return (
        item.selectedServices?.length == 0 &&
        item.fullName == "" &&
        item.customerNote == "" &&
        !item.tech?.fullName &&
        item.technicianNotes == ""
      );
    },
    checkValid() {
      let error = "";
      if (this.timePicker == "") {
        error = "Please select booking time";
      }
      this.customers.map((customer, index) => {
        if (index == 0) {
          if (customer.fullName == "") {
            error = "Please fill your name";
          } else if (customer.selectedServices.length == 0) {
            error = "Please choose service";
          }
        } else {
          if (!this.checkBookingEmpty(customer)) {
            if (customer.selectedServices.length == 0) {
              error = "Please choose service";
            }
          }
        }
        return customer;
      });
      if (error != "") {
        Message({
          message: error,
          type: "error",
          duration: 5 * 1000,
        });
        return true;
      }
      return false;
    },
    getRequestBooking() {
      let ms = 0;
      if (this.timePicker != "") {
        ms =
          Number(this.timePicker.split(":")[0]) * 60 * 60 * 1000 +
          Number(this.timePicker.split(":")[1]) * 60 * 1000;
      }
      const mls =
        new Date(moment(this.datePicker).format("MM/DD/YYYY")).getTime() + ms;
      const country_code = this.phoneNumber.obj.country.dialCode;
      const phone_number = this.phoneNumber.obj.nationalNumber;
      let groupId = null;
      if (this.customers.length > 1) {
        groupId = Math.round(new Date().getTime() / 1000);
      }
      return this.customers
        .filter((ctm) => !this.checkBookingEmpty(ctm))
        .map((customer, index) => {
          const body = {
            technician_notes: customer.technicianNotes,
            requested_id: customer.tech.user_id || 0,
            phone_number: phone_number,
            country_code: "+" + country_code,
            full_name: customer.fullName,
            customer_source: this.source,
            service_ids: customer.selectedServices.map((s) => s.service_id),
            assignee_id: this.technician[0].user_id,
            other_notes: customer.customerNote,
            store: this.storeName,
            agreement_checked: this.checked,
            notes: "",
            time_slot: moment(new Date(mls))
              .utcOffset("-05:00", true)
              .format("YYYY-MM-DD HH:mm:ss.SSSZ"),
            is_booking: true,
            booking_status: -1,
            email: this.email,
          };
          if (groupId) {
            body.group_id = groupId;
            body.group_name = this.customers[0].fullName;
          }
          if (index > 0) {
            body.group_member = customer.fullName;
          }
          return createTicket(body);
        });
    },
    onBookingGroup() {
      if (this.checkValid()) return;
      const loadingInstance = Loading.service({ fullscreen: true });
      Promise.all(this.getRequestBooking())
        .then((results) => {
          this.ticketData = results[0];
          loadingInstance.close();
          if (!results[0].customer.is_phone_number_valid) {
            this.otpDialog = true;
            this.requestOtp();
          } else {
            this.isComplete = true;
            this.checked = false;
            this.emitData();
          }
        })
        .catch((e) => {
          loadingInstance.close();
          console.log(e.message);
        });
    },
    openOtherNote(customerIndex) {
      this.currentCustomerIndex = customerIndex;
      this.dialogNote = true;
    },
    openTechnicianNote(customerIndex) {
      this.currentCustomerIndex = customerIndex;
      this.dialogTechnician = true;
    },
    onSelectedItem(index) {
      const item = this.services[index];
      if (item.type == "Other") {
        this.dialogNote = true;
        return;
      }
      const isSelected =
        this.selectedServices.find((s) => s.service_id == item.service_id) !=
        null;
      if (isSelected) {
        const indexSelected = this.selectedServices.indexOf(item);
        if (indexSelected > -1) {
          this.selectedServices.splice(indexSelected, 1);
        }
      } else {
        this.selectedServices.push(item);
      }
    },
  },
  created() {
    this.storeName = this.$route?.params?.store_name;
    this.isGroup = this.$route.query.group;
    this.groupId = this.$route.query.group_id;
    this.groupName = this.$route.query.group_name;
    if (!this.storeName) {
      Message({
        message: "Invalid Store Name",
        type: "error",
        duration: 5 * 1000,
      });
      return;
    }
    Promise.all([
      getServices(),
      getTechnician(this.storeName),
      getDisplayName(this.storeName),
    ])
      .then((res) => {
        this.services = res[0];
        this.technician = res[1];
        this.storeData = res[2];
      })
      .catch((e) => console.log(e));
  },
};
</script>

<style lang="scss">
.el-dialog--center .el-dialog__body {
  padding: 20px !important;
}
.el-picker-panel__body {
  font-family: "Montserrat";
}
.el-picker-panel__content {
  font-family: "Montserrat";
}
.time {
  .el-input__inner {
    font-weight: 600;
    font-size: 16px;
  }
}
</style>

<style lang="scss" scoped>
.el-select {
  width: calc(50% - 5px);
}
.tech {
  color: #222222;
}
.vue-otp-2 {
  display: flex;
  justify-content: space-evenly !important;
  padding: 0 30px !important;
  div {
    input {
      max-width: 40px !important;
    }
  }
}
.slide-enter-active {
  transition: all 0.3s ease;
}
.slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter, .slide-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(295px);
}
.bottom-checkout-container {
  background-color: white;
  display: flex;
  flex-direction: column;

  .logo-success {
    width: auto;
    height: 100px;
    align-self: center;
    margin-top: 20px;
  }
  .message {
    font-size: 16px;
    font-weight: 600;
    padding: 0 60px;
    align-self: center;
    margin-top: 30px;
    margin-bottom: 30px;
    text-align: center;
  }
  .phone {
    font-size: 16px;
    font-weight: bold;
    align-self: center;
    margin-top: 16px;
  }
  .otp-view {
    margin-left: calc(50% - 250px);
    margin-right: calc(50% - 250px);
  }
  .continue-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    background-image: linear-gradient(to bottom right, #ff4e54, #ff7569);
    border-radius: 5px;
    margin-left: calc(50% - 250px);
    margin-right: calc(50% - 250px);
    margin-top: 30px;
    margin-bottom: 20px;
  }
  .continue-button-disable {
    background-image: linear-gradient(to bottom right, #dddddd, #dddddd);
  }
  @media only screen and (max-width: 600px) {
    .continue-button {
      margin-left: 20px;
      margin-right: 20px;
    }
    .otp-view {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
  }
  .continue-text {
    color: white;
    font-size: 16px;
    font-weight: 700;
  }
}
.confirm-alert {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 4;
}
.overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background-color: rgba($color: #000000, $alpha: 0.5);
}
.booking-information__container {
  box-shadow: 0 5px 10px rgba($color: #000000, $alpha: 0.1);
  padding: 20px 0;
  margin: 20px 20px 20px 20px;
  border-radius: 5px;
  background-color: #fff9ec;
}
.signin-container {
  display: flex;
  flex-direction: column;
  color: #222222;
  padding-left: 70px;
  padding-right: 70px;
  background-color: #fafafa;
  .tech-title {
    font-weight: bold;
    font-size: 18px;
  }
  .icon-info-wrapper {
    height: 20px;
    width: 20px;
    margin-right: 15px;
    display: flex;
    justify-content: center;
  }
  .icon-info {
    height: 16px;
    width: auto;
  }
  .row-info {
    display: flex;
    align-items: center;
    margin-left: 20px;
    margin-right: 20px;
  }
  .store-name {
    font-weight: bold;
    font-size: 20px;
    margin: 10px 20px 0 20px;
  }
  .underline {
    text-decoration: underline;
  }
  .add-button {
    display: flex;
    align-items: center;
    color: #a5a4a3;
    font-weight: 600;
    font-size: 16px;
    margin: 20px 20px 0 20px;
    height: 50px;
    justify-content: center;
    border: 1px dashed #ebeae7;
    background-color: #faf9f5;
    border-radius: 5px;
  }
  .body-container {
    display: flex;
    flex-direction: column;
    ::placeholder {
      color: #696969;
      font-weight: 600;
    }
    .text-field {
      margin-bottom: 20px;
    }
    .input {
      width: 100%;
      border-radius: 5px;
      border: 1px solid #eeeeee;
      background-color: #f9f7f1;
      height: 50px;
      font-size: 16px;
      font-weight: 600;
      outline: none;
      outline-style: none;
      padding: 0 20px;
      box-shadow: none;
    }
    .customer-note {
      margin-top: 15px;
      margin-bottom: 10px;
    }
  }
  .phone-number {
    margin: 0 20px 0 20px;
  }
  .information {
    margin: 10px 20px 0 20px;
    .source-view {
      width: 200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 25px;
      .source-text {
        font-weight: bold;
        font-size: 20px;
      }
    }
  }
  .time {
    margin: 10px 20px 20px 20px;
    .datetime-container {
      display: flex;
      flex: 1;
      flex-direction: column;
      .option {
        padding: 10px 15px;
        background-color: #f9f7f1;
        border: 1px solid #eeeeee;
        border-radius: 5px;
        font-size: 16px;
        font-weight: 600;
      }
      .option-active {
        background-color: #dddddd;
        border: none;
      }
      .date-container {
        display: flex;
        flex-direction: column;
        flex: 1;
        align-items: flex-start;
      }
      .time-container {
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-top: 30px;
      }
    }
    .btn-time-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px;
      height: 50px;
      border: 1px solid #eeeeee;
      border-radius: 5px;
      background-color: #f9f7f1;
      margin: 20px 0;
    }
  }
  .techniciant-field {
    display: flex;
  }
  .list-technician {
    display: flex;
    flex-wrap: wrap;
  }
  .btn-tech {
    padding: 15px;
    border: 1.5px solid #eeeeee;
    border-radius: 6px;
    width: calc(33% - 5px);
    margin-bottom: 10px;
  }
  .left {
    margin-right: 5px;
  }
  .right {
    margin-left: 5px;
  }
  .center {
    margin-left: 5px;
    margin-right: 5px;
  }
  .tech {
    font-weight: 600;
    font-size: 16px;
  }
  .title {
    font-weight: bold;
    font-size: 18px;
  }
  .agreement {
    flex-direction: row;
    margin: 30px 20px 0 20px;
    .agree-text {
      font-size: 18px;
    }
    .icon-check {
      width: auto;
      height: 20px;
      margin-right: 20px;
    }
  }
  .cta-bottom {
    position: fixed;
    height: 100px;
    left: calc(50% - 300px);
    right: calc(50% - 300px);
    bottom: 0px;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: #fafafa;
  }
}
@media only screen and (max-width: 600px) {
  .signin-container {
    padding-left: 0;
    padding-right: 0;
    .cta-bottom {
      left: 20px;
      right: 20px;
      padding-left: 0px;
      padding-right: 0px;
    }
    .tech {
      font-size: 14px;
    }
    .btn-tech {
      width: calc(33% - 6px);
    }
  }
}
</style>